import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledCrossContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
`;

const StyledTimer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 6px;
	background-color: #fabe2c;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

const StyledEditButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	padding: 0 5px;
	border-radius: 6px;
	background-color: #fabe2c;
	transition: background-color 0.3s ease;
	cursor: pointer;

	&:hover {
		background-color: #ffffff;
	}

	${Text} {
		font-weight: 500;
		font-size: 12px;
		color: #000000;
	}
`;

export {
	StyledContainer,
	StyledCrossContainer,
	StyledEditButton,
	StyledRightContainer,
	StyledTimer,
};
